module.exports = __webpack_public_path__ + "img/login-bg.6ad23459.png";